import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
    const [form, setForm] = useState({
        full_name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
    });
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await axios.post(`${API}/contact`, form);
            toast.success("Message envoyé. Nous revenons vers vous très vite.");
            setForm({ full_name: "", email: "", phone: "", subject: "", message: "" });
        } catch {
            toast.error("Impossible d'envoyer le message.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <section
            id="contact"
            data-testid="contact"
            className="py-32 bg-[#FAF9F6]"
        >
            <div className="max-w-[1500px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16">
                <div className="lg:col-span-5 section-fade">
                    <div className="flex items-center gap-3 mb-6">
                        <span className="h-px w-10 bg-[#B89C6A]" />
                        <span className="tracking-luxe text-[#B89C6A]">
                            Contact
                        </span>
                    </div>
                    <h2 className="font-serif-lux text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
                        Parlons de votre <em className="italic text-[#B89C6A]">projet</em>.
                    </h2>
                    <p className="mt-6 text-[14px] text-[#1C1E1D]/70 leading-relaxed max-w-md">
                        Notre équipe vous répond sous 24 heures ouvrées. Confidentialité assurée.
                    </p>

                    <div className="mt-12 space-y-8">
                        <div>
                            <div className="tracking-luxe text-[#B89C6A]">
                                Studio
                            </div>
                            <div className="font-serif-lux text-2xl mt-2">
                                61 Avenue de Breteuil
                                <br />
                                75007 Paris
                            </div>
                        </div>
                        <div>
                            <div className="tracking-luxe text-[#B89C6A]">
                                Téléphone
                            </div>
                            <a
                                href="tel:+33623762847"
                                className="font-serif-lux text-2xl mt-2 block hover:text-[#B89C6A] transition-colors"
                            >
                                06 23 76 28 47
                            </a>
                        </div>
                        <div>
                            <div className="tracking-luxe text-[#B89C6A]">
                                Email
                            </div>
                            <a
                                href="mailto:contact@cmrenov.com"
                                className="font-serif-lux text-2xl mt-2 block hover:text-[#B89C6A] transition-colors"
                            >
                                contact@cmrenov.com
                            </a>
                        </div>
                        <div>
                            <div className="tracking-luxe text-[#B89C6A]">
                                Horaires
                            </div>
                            <div className="font-serif-lux text-lg mt-2 text-[#1C1E1D]/80">
                                Lundi — Vendredi · 9h00 · 18h30
                                <br />
                                Samedi sur rendez-vous
                            </div>
                        </div>
                    </div>
                </div>

                <form
                    onSubmit={submit}
                    className="lg:col-span-7 section-fade lux-card p-8 md:p-12"
                >
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                        <input
                            data-testid="contact-name"
                            className="lux-input"
                            placeholder="Nom et prénom"
                            value={form.full_name}
                            onChange={(e) =>
                                setForm({ ...form, full_name: e.target.value })
                            }
                            required
                        />
                        <input
                            data-testid="contact-email"
                            type="email"
                            className="lux-input"
                            placeholder="Email"
                            value={form.email}
                            onChange={(e) =>
                                setForm({ ...form, email: e.target.value })
                            }
                            required
                        />
                        <input
                            data-testid="contact-phone"
                            className="lux-input"
                            placeholder="Téléphone (facultatif)"
                            value={form.phone}
                            onChange={(e) =>
                                setForm({ ...form, phone: e.target.value })
                            }
                        />
                        <input
                            data-testid="contact-subject"
                            className="lux-input"
                            placeholder="Sujet"
                            value={form.subject}
                            onChange={(e) =>
                                setForm({ ...form, subject: e.target.value })
                            }
                        />
                        <textarea
                            data-testid="contact-message"
                            className="lux-input md:col-span-2 min-h-[140px] resize-none"
                            placeholder="Votre message"
                            value={form.message}
                            onChange={(e) =>
                                setForm({ ...form, message: e.target.value })
                            }
                            required
                        />
                    </div>
                    <div className="mt-10 flex justify-between items-center border-t hairline pt-8">
                        <div className="text-[12px] text-[#1C1E1D]/60">
                            Vos informations restent confidentielles.
                        </div>
                        <button
                            type="submit"
                            data-testid="contact-submit"
                            disabled={busy}
                            className="btn-champagne disabled:opacity-50"
                        >
                            {busy ? "Envoi…" : "Envoyer le message"}
                        </button>
                    </div>
                </form>
            </div>
        </section>
    );
}
